import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	rightSideBarContainerLive: {
		display         : "flex",
		flexDirection   : "column",
		alignItems      : "flex-start",
		position        : "sticky",
		height          : theme.other.isMobile ? "50%" : props?.theatreModeToggle ? "100vh" : "calc(100vh - 70px)",
		top             : props?.theatreModeToggle ? "0" : "70px",
		flex            : "1",
		maxWidth        : props?.chatPoppedOut ? "100%" : "25vw",
		borderLeft      : `0.75px solid ${ theme.other.colors.border.primary }`,
		backgroundColor : "inherit"

	},
	tabText: {
		color      : "inherit",
		fontWeight : "inherit"
	},

	headerTitle: {
		fontWeight: "500"
	},

	mobileHeader: {
		padding        : "1rem",
		background     : theme.other.paletteNew.darkModeInclinedBlack1,
		display        : "flex",
		alignItems     : "center",
		justifyContent : "space-between"
	},
	closeIcon: {
		height : "3rem",
		width  : "3rem"
	}
}
) );
